import { usePageTitle } from "@/util/hooks";

const Page404 = () => {
  usePageTitle("Page not found");

  console.log("rendered 404");

  return (
    <div className="flex h-screen">
      <div className="m-auto text-center">
        <h1 className="text-7xl font-bold">404</h1>
        <p className="text-center text-2xl">Page not found</p>
      </div>
    </div>
  );
};

export default Page404;
